import React, { Component } from 'react'
import { Inputs, Indicators } from '@constants'

import Icon from './Icon'
import Indicator from './Indicator'

const InputOrTextarea = ({ children, type, reference, ...props }) => {
  return type === 'textarea' ? (
    <textarea {...props} {...(reference ? { ref: reference } : {})}>
      {children}
    </textarea>
  ) : (
    <input type={type} {...props} {...(reference ? { ref: reference } : {})} />
  )
}

class Input extends Component {
  constructor(props) {
    super(props)

    this.state = {
      empty: !props.value && !props.defaultValue,
      touched: false,
      focus: false
    }
  }

  focus = (event) => {
    this.setState({ focus: true })
    if (this.props.events.onFocus) this.props.events.onFocus(event)
  }

  blur = (event) => {
    this.setState({ focus: false })
    if (this.props.events.onBlur)
      this.props.events.onBlur(event.target.value, event)
    if (event.target.value !== this.props.value) {
      // IOS chrome autofill needs this (probably a few other browsers too)
      if (this.props.events.onChange)
        this.props.events.onChange(event.target.value, event)
      this.setState({ empty: event.target.value === '' })
    }
  }

  change = (event) => {
    this.setState({
      empty: event.target.value === '',
      touched: true
    })
    if (this.props.events.onChange)
      this.props.events.onChange(event.target.value, event)
  }

  autoFill = (event) => {
    if (event.animationName === 'onAutoFillStart') {
      this.setState({ empty: event.target.value === '' })
      if (this.props.events.onChange)
        this.props.events.onChange(event.target.value, event)
    }
  }

  render() {
    const { state } = this
    const {
      className,
      events,
      wrapperProps,
      inputClassName,
      msg,
      icon,
      iconProps,
      ...props
    } = this.props

    const msgData = Inputs.STATUS[msg.toUpperCase()]

    return (
      <div
        {...wrapperProps}
        className={`ui gp-input  ${msg} ${className}
          ${state.focus ? 'focus' : ''}
          ${state.touched ? 'touched' : ''}
          ${state.empty ? 'empty' : ''}
          ${props.label ? '' : 'no-label'}
          ${props.floatinglabel ? 'floating' : ''}
          ${props.reversed ? 'reversed' : ''}
        `}
      >
        {props.label && props.label}
        {props.floatinglabel && (
          <div
            className={`floating-label ${
              !state.empty || state.focus ? 'is-floating' : ''
            }`}
          >
            {props.floatinglabel}
          </div>
        )}
        <InputOrTextarea
          className={`ui input-field gp-box ${inputClassName}`}
          {...events}
          {...props}
          onFocus={this.focus}
          onBlur={this.blur}
          onChange={this.change}
          onAnimationStart={this.autoFill}
        />
        {(icon || msg) && (
          <Icon
            name={icon || (msgData && msgData.icon)}
            className='msg-icon'
            {...iconProps}
          />
        )}
        {msg && <Indicator type={Indicators[msgData.indicator]} />}
      </div>
    )
  }
}

Input.defaultProps = {
  className: '',
  style: {},
  events: {},
  type: 'text',

  wrapperProps: {},
  inputClassName: 'box-b3',
  msg: '',
  icon: '',
  iconProps: {}
}

export default Input
